import { render, staticRenderFns } from "./edit-ththreshold.vue?vue&type=template&id=7a192d95&"
import script from "./edit-ththreshold.vue?vue&type=script&lang=ts&"
export * from "./edit-ththreshold.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports